var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSingleBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.30988 13.8438H21.8499C22.7777 13.8438 23.5299 14.6273 23.5299 15.5938V19.75H4.62988V15.5938C4.62988 14.6273 5.38204 13.8438 6.30988 13.8438Z",
    stroke: "#77838D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.62988 19.75V22.375",
    stroke: "#77838D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5303 19.75V22.375",
    stroke: "#77838D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6395 13.8438V7.9375C21.6395 7.21263 21.0754 6.625 20.3795 6.625H7.77953C7.08365 6.625 6.51953 7.21263 6.51953 7.9375V13.8438",
    stroke: "#77838D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1398 10.5625H17.0198C17.4837 10.5625 17.8598 10.9543 17.8598 11.4375V13.8438H10.2998V11.4375C10.2998 10.9543 10.6759 10.5625 11.1398 10.5625Z",
    stroke: "#77838D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleBed);
export default __webpack_public_path__ + "static/media/single_bed.9dfc7fbd.svg";
export { ForwardRef as ReactComponent };